export default Object.freeze({
  Stripe: 1,
  BankTransfer: 2,
  Manual: 3,
});
